// Vercel serves this site from www.plusbake.com and 308-redirects the apex
// there. Canonical URLs, og:url, the sitemap and the robots.txt Sitemap: line
// all derive from SITE_URL, so if it names the apex every URL we publish points
// at a redirect and the two hosts split their search signals. Normalize to the
// host that actually serves, whatever VITE_SITE_URL is set to.
const CANONICAL_HOST = "www.plusbake.com"
const APEX_HOST = "plusbake.com"

function normalizeSiteUrl(raw: string): string {
  try {
    const url = new URL(raw)
    if (url.hostname === APEX_HOST) {
      url.hostname = CANONICAL_HOST
    }
    return url.origin
  } catch {
    return raw.replace(/\/+$/, "")
  }
}

export const SITE_URL = normalizeSiteUrl(
  import.meta.env.VITE_SITE_URL || "https://www.plusbake.com"
)

export function getRequestSiteUrl(request?: Request) {
  if (!request) return SITE_URL

  const requestUrl = new URL(request.url)
  const configuredUrl = new URL(SITE_URL)
  const isVercelStagingHost = requestUrl.hostname.endsWith(".vercel.app")
  const configuredIsLaunchDomain = configuredUrl.hostname.endsWith("plusbake.com")

  if (isVercelStagingHost && configuredIsLaunchDomain) {
    return `https://${requestUrl.host}`
  }

  return SITE_URL
}

// Self-hosted 1200x630 share card. Pages without a purpose-made one use this.
// (Five pages pointed at an image on the site builder's CDN that now returns
// 403, so their link previews came up blank.)
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/plusbake/optimized/og-home-1200x630.jpg`
